import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { GridDataResult, PageChangeEvent } from '@progress/kendo-angular-grid';
import { SortDescriptor } from '@progress/kendo-data-query';
import * as _ from 'lodash';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Manufacturer } from 'src/app/models';
import { ManufacturersService } from 'src/app/services/manufacturers.service';

@Component({
  selector: 'app-manufacturers',
  templateUrl: './manufacturers.component.html',
  styles: [],
})
export class ManufacturersComponent implements OnInit {
  public filterValue$: Observable<string>;
  public gridData$: Observable<GridDataResult>;
  public loaded$: Observable<boolean>;
  public pageSize = 40;
  public rowHeight = 30;
  public skip$ = new BehaviorSubject<number>(0);
  public sort$ = new BehaviorSubject<SortDescriptor[]>([
    {
      field: 'partNumber',
      dir: 'asc',
    },
  ]);
  constructor(public dialog: MatDialog, private manufacturersService: ManufacturersService) {}

  ngOnInit() {
    this.loaded$ = this.manufacturersService.loaded$;
    this.filterValue$ = this.manufacturersService.filter$;

    this.gridData$ = combineLatest(this.manufacturersService.filteredEntities$, this.sort$, this.skip$).pipe(
      map(([manufacturers, [sort], skip]) => {
        const data =
          sort.dir === 'asc' ? _.sortBy(manufacturers, sort.field) : _.sortBy(manufacturers, sort.field).reverse();

        const pagedData = data.slice(skip, skip + this.pageSize);
        return { data: pagedData, total: data.length };
      }),
    );
  }

  openNewDialog() {
    this.manufacturersService.openNewDialog().subscribe();
  }
  openEditDialog(manufacturer: Manufacturer) {
    this.manufacturersService.openEditDialog(manufacturer).subscribe();
  }

  delete(manufacturer: Manufacturer) {
    this.manufacturersService.delete(manufacturer);
  }
  filterManufacturers(filter) {
    this.manufacturersService.setFilter(filter);
  }
  public sortChange(sort: SortDescriptor[]) {
    this.sort$.next(sort);
  }

  public pageChange(event: PageChangeEvent) {
    this.skip$.next(event.skip);
  }
}
